import { render, staticRenderFns } from "./SimilarityValue.vue?vue&type=template&id=2efa6153"
import script from "./SimilarityValue.vue?vue&type=script&setup=true&lang=js"
export * from "./SimilarityValue.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports